class ProductStoryImages extends HTMLElement {
  connectedCallback() {
    if (this.isInitialized) return;

    this.panels = [...this.querySelectorAll('.product-story-images__video-panel')].filter((panel) =>
      panel.querySelector('.product-story-images__video')
    );

    if (!this.panels.length) return;

    this.isInitialized = true;
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.handleMotionChange = this.handleMotionChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.motionQuery.addEventListener('change', this.handleMotionChange);

    // 每个视频块维护自己的播放状态，一个 section 里可以放多个
    this.items = this.panels.map((panel) => {
      const video = panel.querySelector('.product-story-images__video');
      const control = panel.querySelector('[data-video-control]');
      const item = {
        panel,
        video,
        control,
        isIntersecting: false,
        // 开启减弱动效时默认不自动播放，由用户主动点击
        isManuallyPaused: this.motionQuery.matches,
      };

      item.onControlClick = () => this.toggle(item);
      item.onPlay = () => this.updatePlaybackState(item, true);
      item.onPause = () => this.updatePlaybackState(item, false);

      control?.addEventListener('click', item.onControlClick);
      video.addEventListener('play', item.onPlay);
      video.addEventListener('pause', item.onPause);
      video.addEventListener('ended', item.onPause);
      video.addEventListener('error', item.onPause);

      return item;
    });

    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(this.handleIntersection, { threshold: 0.25 });
      this.items.forEach((item) => this.observer.observe(item.video));
    } else {
      this.items.forEach((item) => {
        item.isIntersecting = true;
        this.syncPlayback(item);
      });
    }
  }

  toggle(item) {
    if (item.video.paused) {
      item.isManuallyPaused = false;
      this.playVideo(item);
      return;
    }

    item.isManuallyPaused = true;
    item.video.pause();
  }

  // 长页里视频只占一段，离开视口就暂停，避免后台空跑
  handleIntersection(entries) {
    entries.forEach((entry) => {
      const item = this.items.find(({ video }) => video === entry.target);
      if (!item) return;

      item.isIntersecting = entry.isIntersecting;
      this.syncPlayback(item);
    });
  }

  handleMotionChange(event) {
    this.items.forEach((item) => {
      item.isManuallyPaused = event.matches;
      this.syncPlayback(item);
    });
  }

  syncPlayback(item) {
    if (!item.isIntersecting || item.isManuallyPaused || this.motionQuery.matches) {
      item.video.pause();
      return;
    }

    this.playVideo(item);
  }

  playVideo(item) {
    item.video.play().catch(() => this.updatePlaybackState(item, false));
  }

  updatePlaybackState(item, isPlaying) {
    item.panel.classList.toggle('is-playing', isPlaying);

    if (!item.control) return;

    const { playLabel, pauseLabel } = item.control.dataset;
    item.control.setAttribute('aria-pressed', String(isPlaying));
    item.control.setAttribute('aria-label', isPlaying ? pauseLabel : playLabel);
  }

  disconnectedCallback() {
    if (!this.isInitialized) return;

    this.observer?.disconnect();
    this.motionQuery?.removeEventListener('change', this.handleMotionChange);
    this.items.forEach((item) => {
      item.control?.removeEventListener('click', item.onControlClick);
      item.video.removeEventListener('play', item.onPlay);
      item.video.removeEventListener('pause', item.onPause);
      item.video.removeEventListener('ended', item.onPause);
      item.video.removeEventListener('error', item.onPause);
      item.video.pause();
    });
    this.isInitialized = false;
  }
}

if (!customElements.get('product-story-images')) {
  customElements.define('product-story-images', ProductStoryImages);
}
